import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import VocabulariesPanelFull from '../containers/VocabulariesPanelFull';
import VocabulariesPanelNarrow from '../containers/VocabulariesPanelNarrow';

const VocabulariesPanel = ({ configuration }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: VocabulariesPanelFull, narrow: VocabulariesPanelNarrow }}
  />
);

export default VocabulariesPanel;
